var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page",class:{'pad-safely': _vm.padSafely}},[_c('div',{staticClass:"page-inner",class:{
        'fixed-header': _vm.headerConfig.enabled && _vm.headerConfig.fixed,
        'overlap-header': _vm.headerConfig.enabled && _vm.headerConfig.overlap,
        'fixed-footer': _vm.footerConfig.enabled && _vm.footerConfig.fixed
      }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }